import { render, staticRenderFns } from "./SuratEdaranAnggota.vue?vue&type=template&id=73146faf&"
import script from "./SuratEdaranAnggota.vue?vue&type=script&lang=js&"
export * from "./SuratEdaranAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports